const tableData = {
  "en-GB": {
    ordersPerYear: "Orders per year",
    totalCost: "Total delivery cost",
    withoutPremier: "Without ASOS Premier*",
    withPremier: "With ASOS Premier",
  },
  "en-AU": {
    ordersPerYear: "Orders per year",
    totalCost: "Total delivery cost",
    withoutPremier: "Without ASOS Premier*",
    withPremier: "With ASOS Premier",
  },
  "de-DE": {
    ordersPerYear: "Bestellungen pro Jahr",
    totalCost: "Gesamte Lieferkosten",
    withoutPremier: "Ohne ASOS Premier*",
    withPremier: "Mit ASOS Premier",
  },
  "es-ES": {
    ordersPerYear: "Pedidos al año",
    totalCost: "Total de Gastos de envío",
    withoutPremier: "Sin ASOS Premier*",
    withPremier: "Con ASOS Premier",
  },
  "fr-FR": {
    ordersPerYear: "Commandes par an",
    totalCost: "Coût de livraison total",
    withoutPremier: "Sans ASOS Premier *",
    withPremier: "Avec ASOS Premier",
  },
  "it-IT": {
    ordersPerYear: "Ordini all'anno",
    totalCost: "Costo totale della spedizione",
    withoutPremier: "Senza ASOS Premier *",
    withPremier: "Con ASOS Premier",
  },
  "ru-RU": {
    ordersPerYear: "Заказов в год",
    totalCost: "Общая стоимость доставки",
    withoutPremier: "Без доставки ASOS Premier *",
    withPremier: "С доставкой ASOS Premier",
  },
  "en-US": {
    ordersPerYear: "Orders per year",
    totalCost: "Total delivery cost",
    withoutPremier: "Without ASOS Premier*",
    withPremier: "With ASOS Premier",
  },
  "nl-NL": {
    ordersPerYear: "Bestellingen per jaar",
    totalCost: "Totale verzendkosten",
    withoutPremier: "Zonder ASOS Premier*",
    withPremier: "Met ASOS Premier",
  },
  "sv-SE": {
    ordersPerYear: "Beställningar per år",
    totalCost: "Total leveranskostnad",
    withoutPremier: "Utan ASOS Premier*",
    withPremier: "Med ASOS Premier",
  },
  "da-DK": {
    ordersPerYear: "Bestillinger om året",
    totalCost: "Samlede leveringsomkostninger",
    withoutPremier: "Uden ASOS Premier*",
    withPremier: "Med ASOS Premier",
  },
  "pl-PL": {
    ordersPerYear: "Liczba zamówień na rok",
    totalCost: "Łączny koszt dostawy",
    withoutPremier: "Bez ASOS Premier*",
    withPremier: "Z ASOS Premier",
  },
};

export default tableData;
